import { enums, IPriceAlert, ITicker } from '@kattana-io/common';
import { createSelector } from 'reselect';
import { IStore } from '../reducers';

const createGetAlerts = (ticker: ITicker) =>
  createSelector(
    (state: IStore) => state.price_alerts.pending || [],
    (pendingAlerts: IPriceAlert[]): IPriceAlert[] =>
      pendingAlerts.filter(
        (item) =>
          item.pair === ticker.address &&
          item.chain === ticker.chain &&
          item.status == enums.PriceAlertStatus.WATCH
      )
  );

const getWatchedPriceAlerts = createSelector(
  (state: IStore) => state.price_alerts.pending || [],
  (pendingAlerts: IPriceAlert[]): IPriceAlert[] =>
    pendingAlerts.filter((item) => item.status == enums.PriceAlertStatus.WATCH)
);

export { createGetAlerts, getWatchedPriceAlerts };
